import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional, Silent } from "@/__main__/data-model.mjs";

export const model = {
  name: Optional(String),
  origin: [String],
  class: [String],
  code: Optional(Number),
  role: Optional(String),
  cost: Number,
  ability: {
    name: Silent(String),
    description: Silent(String),
    type: Silent(String),
    manaCost: Silent(Number),
    manaStart: Silent(Number),
    stats: [
      {
        type: String,
        value: String,
      },
    ],
  },
  stats: {
    offense: Silent({
      damage: Silent(Number),
      attackSpeed: Silent(Number),
      range: Silent(Number),
    }),
    defense: Silent({
      health: Silent(Number),
      armor: Silent(Number),
      magicResist: Silent(Number),
    }),
  },
  id: Optional(String),
} satisfies ModelDefinition;

const TftSetModel = createModel(model);

export type TftSet = FromModel<typeof TftSetModel>;

export default TftSetModel;
